<script setup>
import { computed } from 'vue'
import { wordDiff } from '@addictivegroup/addictive-richtext/schema'

/** A short text against the one it replaced, word to word (D-168): dropped words struck, added ones in the colour of changes. */
const props = defineProps({ was: { type: String, default: '' }, now: { type: String, default: '' }, tone: { type: String, default: 'catalogue' } })
const parts = computed(() => wordDiff(props.was, props.now))
</script>

<template>
  <span :class="['doc-words', `doc-vs-${tone || 'catalogue'}`]" data-testid="word-diff"><template v-for="(p, i) in parts" :key="i"><span v-if="p.type === 'same'">{{ p.text }}</span><span v-else-if="p.type === 'del'" class="removed">{{ p.text }}</span><span v-else class="changed">{{ p.text }}</span></template></span>
</template>
